module.exports = __webpack_public_path__ + "img/basement-furnace.87d60919.svg";